import React, { Suspense } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import CustomRoutes from './routes'
import Loader from 'components/ui-kit/Loader/index'

const Routes = () => (
  <Router>
    <Suspense fallback={<Loader component='page' />}>
      <CustomRoutes />
    </Suspense>
  </Router>
)

export default Routes
